import { API_URL } from '../../../app-config/constants';
import { FeedbackTemplateOrder, FeedbackTemplateType } from '../../../types/FeedbackTemplateDto';
import { get, put } from '../request';

const getBaseUrl = (type: FeedbackTemplateType) => `${API_URL}/feedback/template/${type}/order`;

getOrder.operation = 'READ';
export function getOrder(type: FeedbackTemplateType = 'ANYTIME') {
    return get<{ id: string; order: string[] }>(getBaseUrl(type));
}

updateOrder.operation = 'UPDATE';
export function updateOrder(order: FeedbackTemplateOrder, type: FeedbackTemplateType = 'ANYTIME') {
    return put<{ id: string; order: string[] }>(getBaseUrl(type), { postData: order });
}
